import { StatusIcon } from "components/advertising/commonComponents";
import { SMALL_DEVICE_MEDIA_SIZE } from "components/common/constants";
import log from "loglevel";
import React from "react";
import { connect } from "react-redux";
import Select from "../common/Select";

import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import MultiOptionsSwitch from "components/common/form/MultioptionSwitch";
import PropTypes from "prop-types";

export const StatusOptionLabel = (opt, state) => {
    const status = { id: opt.value };

    if (state.context === "menu") {
        return (
            <div style={{ display: "inline-flex" }}>
                <StatusIcon status={status} />
                {opt.label}
            </div>
        );
    } else {
        return (
            <div style={{ display: "inline-flex" }}>
                <StatusIcon style={{ fontSize: 15, marginTop: 3 }} status={status} />
                {opt.label}
            </div>
        );
    }
};
class ReviewStatusTypesSelect extends React.Component {
    static defaultProps = {
        placeholder: "Status",
    };
    constructor(props) {
        super(props);
        this.state = {
            value: props.defaultValue ? props.defaultValue : props.multiple ? [] : null,
        };
        this.onChange = this.onChange.bind(this);
    }
    onChange(value) {
        log.debug("reviewstatus type select", value);
        this.setState({ value }, () => {
            this.props.onChange(this.state.value);
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue });
        }
    }

    isBtnView = () => this.props.showBtnOptions && !this.props.isSmallDevice;

    render() {
        const { value } = this.state;
        const { reviewStatusTypes, multiple, placeholder, selectProps } = this.props;
        const otherProps = Object.assign({}, selectProps, {});
        const statusTypes = reviewStatusTypes
            .filter((type) => type.name !== "")
            .map((type) => ({ value: type.id, label: type.name }));
        if (this.isBtnView()) {
            const _v = value ? value.value : null;
            return <MultiOptionsSwitch value={_v} onChange={this.onChange} options={statusTypes} />;
        }
        return (
            <Select
                placeholder={placeholder}
                value={value}
                multiple={multiple}
                defaultMenuPortalTarget
                formatOptionLabel={StatusOptionLabel}
                onChange={this.onChange}
                options={statusTypes}
                {...otherProps}
            />
        );
    }
}

ReviewStatusTypesSelect.propTypes = {
    onChange: PropTypes.func,
    defaultValue: PropTypes.any,
    reviewStatusTypes: PropTypes.arrayOf(PropTypes.object),
    multiple: PropTypes.bool,
    placeholder: PropTypes.string,
    selectProps: PropTypes.object,
    showBtnOptions: PropTypes.bool,
    isSmallDevice: PropTypes.bool,
};

ReviewStatusTypesSelect.defaultProps = {
    selectProps: {},
};
const HookWrap = (props) => {
    const theme = useTheme();
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(SMALL_DEVICE_MEDIA_SIZE));
    return <ReviewStatusTypesSelect {...props} isSmallDevice={isSmallDevice} />;
};
export default connect(
    ({ globalApp }) => ({
        reviewStatusTypes: globalApp.reviewStatusTypes,
    }),
    null
)(HookWrap);
